"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get EmployeeMeetingStatsDateRange () {
        return EmployeeMeetingStatsDateRange;
    },
    get EmployeeMeetingStatsSearchServiceQueryParams () {
        return EmployeeMeetingStatsSearchServiceQueryParams;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _base = require("../base");
const EmployeeMeetingStatsDateRange = _zod.z.enum([
    "all_time",
    "past",
    "upcoming"
]);
const EmployeeMeetingStatsSearchServiceQueryParams = _base.BaseSearchServiceQueryParams.extend({
    service: _zod.z.literal("employee_meeting_stats"),
    // Employee name search (text input at the top of the page).
    name_re: _zod.z.string().optional(),
    // Filter-panel filters. `id` matches the user, `manager` matches user.manager,
    // `department` matches user.department (a "Group" is a department entity).
    id_eq: _utilsisomorphic.transformObjectId.optional(),
    manager_eq: _utilsisomorphic.transformObjectId.optional(),
    department_eq: _utilsisomorphic.transformObjectId.optional(),
    // Meeting date window the stats are computed within. Handled specially by the
    // service (not through `searchFields`).
    date_range: EmployeeMeetingStatsDateRange.optional(),
    // Only return employees with zero meetings in the selected date window.
    without_meetings: _utilsisomorphic.transformStringToBoolean.optional()
});
